import useCollection from '../competition-info/submission/hooks/useCollection'

export default function usePasswords() {
  const { documents } = useCollection('passwords')

  if (!documents) {
    return {}
  }

  const passwords = Object.values(documents)
    .map(doc => Object.entries(doc).map(([id, value]) => ({ id, value })))
    .flat()

  const passwordToDownloadAuthor = passwords.find(
    password => password.id === 'download_author_info'
  )

  return {
    passwordToDownloadAuthor
  }
}
